<!--
 * @Author: andy_chen
 * @created: 2018-10-23 15:57:46
 * 回复我的
-->

<template>
    <div class="container">
        <div v-if="!isBlank">
            <div v-infinite-scroll="loadMore" infinite-scroll-disabled="disableCheckScroll" infinite-scroll-immediate-check="false" infinite-scroll-distance="50">
                <router-link :to="{ path: `/topicDetail/${visitor.topicId}`}" v-for="(visitor,index) in list" :key="index">
                    <user-info :userInfo="visitor">
                        <div slot="operator" class="operator">
                            <p class="time">{{visitor.createdTime | timeAgo}}回复了你</p>
                            <i class="arrow-right">
                                <svg-icon class="arrow-icon" icon-class="vertical-arrow" /></i>
                        </div>
                    </user-info>
                </router-link>
            </div>
            <p v-show="loading" class="page-infinite-loading">
                <span class="page-infinite-text">加载中</span>
                <spinner size="0.8rem" type="triple-bounce"></spinner>
            </p>
            <p v-show="isEnd" class="page-infinite-nomore">
                <span>没有更多了</span>
            </p>
        </div>
        <blank class="blank-box" v-if="isBlank" text="喵～没有信息哦～">
        </blank>
    </div>
</template>

<script>
import { getReplyMeList } from "../api/user.js";
import UserInfo from "@/components/UserInfo";
import Spinner from "@/components/Spinner/index";
import Blank from "@/components/Blank/index";

export default {
    name: "visitorList",
    components: {
        UserInfo,
        Spinner,
        Blank
    },
    data() {
        return {
            list: [],
            currentPage: 1,
            pageSize: 30,
            loading: false,
            isEnd: false
        };
    },

    computed: {
        disableCheckScroll() {
            return this.loading || this.isEnd;
        },
        isBlank() {
            return this.isEnd && this.list.length === 0;
        }
    },

    mounted() {
        this.loadMore();
    },

    methods: {
        loadMore() {
            this.loading = true;
            this.appendReplyMeList().then(() => {
                this.loading = false;
            });
        },

        appendReplyMeList() {
            let params = {
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            return getReplyMeList(params).then(res => {
                if (+res.code === 200) {
                    this.list = [...this.list, ...res.data];
                    this.currentPage = this.currentPage + 1;
                    this.isEnd = res.data.length < this.pageSize; //当返回的数据小于请求的数量，说明已经没有更多数据了
                } else {
                    this.$toast.open({ msg: res.msg });
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
@import "../style/function.scss";
@import "../style/config.scss";

.container {
    background: $baseBackgroundColor;
}

.operator {
    position: relative;
    color: $secondaryColor;
    font-size: 0.24rem;
    .time {
        padding-right: 0.47rem;
    }
}

.arrow-right {
    position: absolute;
    right: 0.2rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0.24rem;
    color: #979797;
}

.arrow-icon {
    transform: rotate(180deg);
}

.page-infinite-loading {
    height: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.page-infinite-text {
    padding-right: 0.1rem;
    color: $secondaryColor;
}

.page-infinite-nomore {
    height: 1rem;
    line-height: 1rem;
    text-align: center;
    color: $secondaryColor;
}

.blank-box {
    padding-top: 3.22rem;
}
</style>
